import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  return {
    needed: jsonNode.type === 'DOM' && jsonNode.data?.tag === 'br',
    logData: {
      msg: `LineBreak json nodes should be a plugin component.`,
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.type = 'LineBreak';
      jsonNode.data = {
        sym: {
          inst: 'LineBreak',
        },
      };
      jsonNode.tag = 'br';
    },
  };
};
